/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_10_TitleInputs */

const en_terms_section_10_title = /** @type {(inputs: Terms_Section_10_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Governing Law`)
};

const lv_terms_section_10_title = /** @type {(inputs: Terms_Section_10_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Piemērojamie tiesību akti`)
};

/**
* | output |
* | --- |
* | "10. Governing Law" |
*
* @param {Terms_Section_10_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_10_title = /** @type {((inputs?: Terms_Section_10_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_10_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_10_title(inputs)
	return en_terms_section_10_title(inputs)
});